import React from 'react';
import { FormGroup, FormFeedback, Label } from 'reactstrap';
import addErrorClassName from '../helper/addErrorClassName';
import { ErrorMessage } from 'formik';
import '../../../components/FormComponents/styles.scss';

const CustomFormFeedback = ({ children }) => <FormFeedback className="styled-form-feedback">{children}</FormFeedback>;

const SelectFormGroup = ({ label, name, errors, touched, errorName, children }) => {
  return (
    <FormGroup>
      <Label className={`profile-select-label ${addErrorClassName(errors, touched, name)}`}>{label}</Label>
      {children}
      <ErrorMessage name={errorName} component={CustomFormFeedback} />
    </FormGroup>
  );
};

export default SelectFormGroup;
